/**
 * pi-nonograms - A game of nonograms
 * https://github.com/DomenicoDeFelice/Pi-Nonograms
 *
 * Copyright (c) 2013-2020 Domenico De Felice
 * Released under the GNU GPL v3 License
 *
 * @license
 * @format
 * @flow
 */

import type { Cell } from './Model.js';

class DragHelper {
  _dragging: boolean = false;
  _guess: Cell;
  _x1: number;
  _x2: number;
  _y1: number;
  _y2: number;

  start = (x: number, y: number, guess: Cell): void => {
    this._x1 = this._x2 = x;
    this._y1 = this._y2 = y;
    this._guess = guess;

    this._dragging = true;
  };

  to = (x: number, y: number): void => {
    this._x2 = x;
    this._y2 = y;
  };

  stop = (): void => {
    this._dragging = false;
  };

  isDragging = (): boolean => {
    return this._dragging;
  };

  iterateOverDraggedCells = (fn: (number, number, Cell) => void) => {
    const x1 = this._x1;
    const y1 = this._y1;
    const x2 = this._x2;
    const y2 = this._y2;

    let fromX, toX, stepX, fromY, toY, stepY;

    if (Math.abs(x1 - x2) > Math.abs(y1 - y2)) {
      // Horizontal Line
      stepX = 1;
      stepY = 0;

      fromY = toY = y1;

      if (x1 < x2) {
        fromX = x1;
        toX = x2;
      } else {
        fromX = x2;
        toX = x1;
      }
    } else {
      // Vertical line
      stepX = 0;
      stepY = 1;

      fromX = toX = x1;

      if (y1 < y2) {
        fromY = y1;
        toY = y2;
      } else {
        fromY = y2;
        toY = y1;
      }
    }

    for (
      let x = fromX, y = fromY;
      x <= toX && y <= toY;
      x += stepX, y += stepY
    ) {
      fn(x, y, this._guess);
    }
  };
}

module.exports = DragHelper;
